import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PayoutTransactionService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getPayoutTransactions(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/PayoutTransaction/GetPayoutTransactions', data, messageService);
    }
}
